export const selectDistributors = (state) => state.distributor.list;
export const selectDistributorCount = (state) => state.distributor.count;
export const selectDistributorTotalPages = (state) => state.distributor.totalPages;
export const selectDistributorCurrentPage = (state) => state.distributor.currentPage;
export const selectDistributorLoading = (state) => state.distributor.loading;
export const createDistributorLoading = (state) => state.distributor.createLoading;
export const selectDistributorError = (state) => state.distributor.error;

